import { Flex, Icon, sizes, Text, useCollapse } from '@electricjs/arc';
import styled from 'styled-components';

const FlexStyled = styled(Flex)`
  &:hover {
    cursor: pointer;
  }
`;

export const InlineAccordion = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => {
  const { size_40 } = sizes;
  const { visible, toggle } = useCollapse({ visible: false });

  // Stops propagation for the whole component (header + expanded content)
  // — preserved separately from the toggle handler below so that if this
  // ever sits inside a clickable row/card (e.g. a grid card linking to
  // another page), clicking anywhere in the accordion, including its
  // content, still can't trigger that outer click-through.
  const stopPropagation = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  const handleHeaderClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    toggle();
  };

  return (
    <Flex
      flexDirection="column"
      onClick={stopPropagation}
      data-arc="collapsible">
      <FlexStyled flexGrow={1} alignItems="center" onClick={handleHeaderClick}>
        <Flex width={size_40}>
          {visible ? (
            <Icon icon="chevron-up" size="xsmall" />
          ) : (
            <Icon icon="chevron-down" size="xsmall" />
          )}
        </Flex>
        <Text variant="body-2">{label}</Text>
      </FlexStyled>
      {visible && <Flex ml={size_40}>{children}</Flex>}
    </Flex>
  );
};
